import gql from 'graphql-tag';

export const MUTATION_GENERATE_CAPTCHA = gql`
  mutation mutationGenerateCaptcha(
    $captchaSize: Int!
    $validationHeight: Int!
    $validationWidth: Int!
  ) {
    generateCaptcha(
      captchaSize: $captchaSize
      validationHeight: $validationHeight
      validationWidth: $validationWidth
    ) {
      captchaId
      validation
    }
  }
`;

export const MUTATION_SEND_PHONE_CODE = gql`
  mutation mutationSendPhoneCode(
    $captchaCode: String
    $captchaId: String
    $phone: String!
    $type: CodeType!
  ) {
    sendPhoneCode(captchaCode: $captchaCode, captchaId: $captchaId, phone: $phone, type: $type) {
      success
    }
  }
`;

export const QUERY_CHECK_LANDLORD_EXIST = gql`
  query QueryCheckLandlordExist($type: LoginType!, $value: String!) {
    checkLandlordExist(type: $type, value: $value) {
      exist
      roles
    }
  }
`;

export const QUERY_CEHCK_AGENT_USER_EXITS = gql`
  query CheckUserExist($type: LoginType!, $value: String!) {
    checkUserExist(type: $type, value: $value) {
      exist
    }
  }
`;
export const MUTATION_LANDLORD_ACCOUNT_LOGIN = gql`
  mutation mutationLandlordAccountLogin($input: LandlordAccountLoginInput) {
    landlordAccountLogin(input: $input) {
      authToken
    }
  }
`;

export const MUTATION_LANDLORD_ACCOUNT_SIGNUP = gql`
  mutation mutationLandlordAccountSignup($input: LandlordAccountSignUpInput) {
    landlordAccountSignUp(input: $input) {
      authToken
    }
  }
`;

export const MUTATION_VERIFY_PHONE_CODE = gql`
  mutation mutationVerifyPhoneCode($input: VerifyPhoneCodeInput) {
    verifyPhoneCode(input: $input) {
      success
    }
  }
`;

export const QUERY_GET_SEND_PHONE_CODE_LAST_TIME = gql`
  query QueryGetSendPhoneCodeLastTime($phone: String!, $type: CodeType!) {
    getSendPhoneCodeLastTime(phone: $phone, type: $type) {
      lastSendTime
    }
  }
`;
